import React from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useNotificationStore } from "@/store/notificationStore";
import { GreenCheckIcon, RedErrorIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

const Notification: React.FC = () => {
  const { notifications } = useNotificationStore();

  return ReactDOM.createPortal(
    <div className={cls.notificationContainer}>
      <AnimatePresence mode="wait">
        {notifications.map((notif) => (
          <motion.div
            key={notif.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
            className={cls.notification}
            data-type={notif.type}
          >
            {notif.type === "success" && <GreenCheckIcon />}
            {notif.type === "error" && <RedErrorIcon />}
            {notif.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>,
    document.body
  );
};

export default Notification;
